<template>
  

  <v-container fluid>


    <!-- Diálogo para Crear/Editar -->
    <v-dialog persistent v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>

            <v-row>
              <v-col cols="12">
                <VueDatePicker model-type="yyyy-MM-dd" v-model="editedItem.DATE_RO" 
                :format="'yyyy-MM-dd'" text-input :teleport="true"
                :disabled-dates="disableNonFirstDays"
                :readonly="editedIndex > -1"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.VALUE"
                  :label="$t('maestros.ro.valor')"
                  required
                ></v-text-field>
              </v-col>
            </v-row>

          </v-container>
        </v-card-text>
        <v-card-actions>
          <p v-if="isSaving">{{$t('maestros.ro.guardando')}}</p>
          <v-spacer></v-spacer>
          <v-btn text @click="close">{{$t('maestros.ro.cancelar')}}</v-btn>
          <v-btn text @click="guardarItem">{{$t('maestros.ro.guardar')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  
      <ComponenteLoading :is-loading="loading" :message="mensaje_loading"></ComponenteLoading>

      
     

        <v-data-table
        density="compact"
        
        :headers="cabecera_ro"
        :items="lista_ro"
          
          class="elevation-1 gris_muy_suave"   
       
      >
      


        <template v-slot:top>
          
          <v-toolbar flat color="white" style="padding-bottom: 20px;"   >
            
            <v-toolbar-title class="mb-6"><div class="ml-5 mt-3 text-caption gris_suave"></div>{{$t('maestros.ro.titulo')}}</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
             
            <v-btn  class="boton_crear selected" dark @click="nuevoItem"><span class="material-symbols-outlined">add</span>{{$t('maestros.ro.nuevo')}}</v-btn>
            <v-btn  class="gris_medio" @click="obtenerRo"><span class="material-symbols-outlined">autorenew</span>{{$t('maestros.ro.actualizar')}}</v-btn>

          </v-toolbar>
         
        </template>
        


        <template v-slot:item="{ item }">
  
          <tr>
          <td>{{ item.DATE_RO }}</td>            
          <td>{{ item.VALUE }}</td>            
          <td>{{ item.USER_MOD }}</td> 
          <td>{{ item.DATETIME_MOD }}</td> 



          <td style="justify-content: left !important;">
            <div class="icon-container" >

              <!-- Ícono para "Editar item" -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon 
                    @click="editarItem(item)"
                    v-bind="attrs" 
                    v-on="on"
                    class="clickable-icon"
                    style="margin-right: 12px;"
                  >
                  <span class="material-symbols-outlined">edit</span>
                  </v-icon>
                </template>
                {{$t('maestros.ro.editar')}}
              </v-tooltip>

              <!-- Ícono para "Borrar item" -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon 
                    @click="deleteItem(item)" 
                    v-bind="attrs" 
                    v-on="on"
                    class="sentimiento_rojo clickable-icon"
                  >
                    <span class="material-symbols-outlined">delete</span>
                  </v-icon>
                </template>
                {{$t('maestros.ro.borrar')}}
              </v-tooltip>
            </div>
          </td>


          </tr> 
  
        </template>

        </v-data-table>
       
       

  </v-container>








</template>


<script>
import store from '../../store';
import axios from 'axios';
import '@vuepic/vue-datepicker/dist/main.css'
import ComponenteLoading from './../ComponenteLoading.vue';
import Swal from "sweetalert2";


export default {




    data() {
        return {
          
          usuario: store.state.usuarioNombre,          
          loading: false,
          mensaje_loading: "",         
    
          lista_ro: [],

          cabecera_ro: [
              { title: this.$t('maestros.ro.tabla.fecha'), key: 'DATE_RO' ,headerProps:{class:'header-custom'}},            
              { title: this.$t('maestros.ro.tabla.valor'), key: 'VALUE',headerProps:{class:'header-custom'} },              
              { title: this.$t('maestros.ro.tabla.usuario_mod'), key: 'USER_MOD',headerProps:{class:'header-custom'} },
              { title: this.$t('maestros.ro.tabla.fecha_mod'), key: 'DATETIME_MOD',headerProps:{class:'header-custom'} },                              
              { title: this.$t('maestros.ro.tabla.acciones'), key: 'actions', sortable: false, headerProps:{class:'header-custom', } },
          ],

          isSaving: false,            
          
          dialog: false,          
          editedIndex: -1,
          editedItem: { DATE_RO: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, "0")}-01`, VALUE: 0, USER_MOD: ""},
          defaultItem: { DATE_RO: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, "0")}-01`,  VALUE: 0, USER_MOD: "" },
         
        };
      },

  watch: {    
    
    '$i18n.locale'() {
      
        this.cabecera_ro = [
                { title: this.$t('maestros.ro.tabla.fecha'), key: 'DATE_RO' ,headerProps:{class:'header-custom'}},            
                { title: this.$t('maestros.ro.tabla.valor'), key: 'VALUE',headerProps:{class:'header-custom'} },              
                { title: this.$t('maestros.ro.tabla.usuario_mod'), key: 'USER_MOD',headerProps:{class:'header-custom'} },
                { title: this.$t('maestros.ro.tabla.fecha_mod'), key: 'DATETIME_MOD',headerProps:{class:'header-custom'} },                              
                { title: this.$t('maestros.ro.tabla.acciones'), key: 'actions', sortable: false, headerProps:{class:'header-custom', } },
        ]

    },



  },


    components: {
        ComponenteLoading,
    },

    async mounted(){
      await this.obtenerRo();
    },

    computed:{
           
    },

    created(){

    },
    
    methods: {

      disableNonFirstDays(date) {
        // Si el día NO es 1, lo deshabilita
        return date.getDate() !== 1
      },

      async obtenerRo() {
        try {
          const response = await axios.get(
            process.env.VUE_APP_API_BASE_URL + "/api/ro",
            {
              headers: { Authorization: "Bearer " + store.state.token },
            }
          );
          this.lista_ro = response.data;
        } catch (error) {
          console.error("Error al obtener ro:", error);
        }
      },

      nuevoItem() {
        this.dialog = true;
      },

      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },

      editarItem(item) {
        this.editedIndex = this.lista_ro.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },

      async deleteItem(item) {


      
        const result = await Swal.fire({
          title: this.$t('mensajes.estas_seguro'),
          text: this.$t('maestros.ro.mensajes.borrar_valor') + item.DATE_RO,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t('comun.boton_ok'),
          cancelButtonText: this.$t('comun.boton_cancelar'),
        });

        if (result.isConfirmed) {

          try {
            let result = await axios.delete(
              process.env.VUE_APP_API_BASE_URL + "/api/ro/" + item.DATE_RO,
              {
                headers: { Authorization: "Bearer " + store.state.token },
              }
            );

            if (result['data']['status']=="error"){
              Swal.fire("Error", result['data']['message'], "error");
            } 

            this.obtenerRo();
          } catch (error) {
            console.error("Error al eliminar item:", error);
          }
        }
      },

      async guardarItem() {
        this.editedItem.USER_MOD = store.state.usuarioNombre;
        this.isSaving = true;
        try {
          if (this.editedIndex > -1) {
            // Update
            let result = await axios.put(
              process.env.VUE_APP_API_BASE_URL +
                "/api/ro/" +
                this.editedItem.DATE_RO,
              this.editedItem,
              { headers: { Authorization: "Bearer " + store.state.token } }
            );            

            if (result['data']['status']=="error"){
              Swal.fire("Error", result['data']['message'], "error");
            }             
            
          } else {
            // Create
            let result = await axios.post(
              process.env.VUE_APP_API_BASE_URL + "/api/ro/",
              this.editedItem,
              { headers: { Authorization: "Bearer " + store.state.token } }
            );

            if (result['data']['status']=="error"){
              Swal.fire("Error", result['data']['message'], "error");
            } 

          }
          this.obtenerRo();
        } catch (error) {
          console.error("Error al guardar item:", error);
        } finally {
          this.isSaving = false;
          this.close();
        }
      },

    },

}
</script>


<style scoped>
.icon-container {
  display: flex;
  justify-content: left;
  align-items: center;
}


/* Animación simple para el ícono */
.spin-icon {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

::v-deep(.v-data-table-footer) {
  color: #686868; 
  font-weight: bold; 
}




</style>